import { render, staticRenderFns } from "./GatewayLightSwitchSpotWidget.vue?vue&type=template&id=67fc716c&lang=pug&"
import script from "./GatewayLightSwitchSpotWidget.vue?vue&type=script&lang=ts&"
export * from "./GatewayLightSwitchSpotWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports